// extracted by mini-css-extract-plugin
module.exports = {"faqSection":"FaqSectionComponent_faqSection__Yqx2G","gwSectionContainer":"FaqSectionComponent_gwSectionContainer__0GSq4"};